export class Status {
    constructor(public status : string){

    }
}
